// 模块级容器，存放当前 widget login 流程的 customization / rootClass / antdToken。
// widget 的 login() 在每次开抽屉前把这三样塞进来；complete 弹窗被异步触发时从这里读，
// 保持跟登录抽屉同一份主题和文案。
import type { LoginCustomization } from "../customization";

export const completeContext: {
  customization: LoginCustomization;
  rootClass: string;
  antdToken: Record<string, unknown>;
} = {
  customization: {},
  rootClass: "",
  antdToken: {},
};

export const setCompleteContext = (next: typeof completeContext): void => {
  completeContext.customization = next.customization;
  completeContext.rootClass = next.rootClass;
  completeContext.antdToken = next.antdToken;
};
